<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "domainVariablesDialog.title" | translate }}</h2>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="onClose()"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body domain-vars-dialog__body">
    <p class="domain-vars-dialog__desc">
      {{ "domainVariablesDialog.desc" | translate }}
    </p>
    <mat-form-field appearance="outline" class="domain-vars-dialog__search">
      <input
        matInput
        type="search"
        [formControl]="searchControl"
        [placeholder]="'domainVariablesDialog.search' | translate"
        [attr.aria-label]="'domainVariablesDialog.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
    @if (filteredTokens.length === 0) {
      <p class="domain-vars-dialog__empty">
        {{ "domainVariablesDialog.empty" | translate }}
      </p>
    } @else {
      <ul class="domain-vars-dialog__list">
        @for (token of filteredTokens; track token) {
          <li>
            <button
              type="button"
              class="domain-vars-dialog__item"
              (click)="onCopy(token)"
            >
              <code>{{ token }}</code>
              <mat-icon>content_copy</mat-icon>
            </button>
          </li>
        }
      </ul>
    }
  </div>
</div>
